import { AlertTriangle } from 'lucide-react';

import i18n from '@/core/i18n';

interface EmptyDescriptionWarningIconProps {
  onClick: () => void;
}

/**
 * Warning affordance shown next to a project/member name when any of its
 * time entries is missing a description. Clicking opens the explanatory modal.
 */
export function EmptyDescriptionWarningIcon({ onClick }: EmptyDescriptionWarningIconProps) {
  return (
    <button
      type="button"
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      aria-label={i18n.t('authenticated.timeTracking:approvals.emptyDescription.iconAriaLabel')}
      className="flex shrink-0 items-center justify-center text-warning hover:opacity-80"
    >
      <AlertTriangle size={16} strokeWidth={2} />
    </button>
  );
}
